import { commentItems } from '@/mocks/cinema';

export default function SectionComments() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="section-container px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-100 mb-3">
            观众热评
          </h2>
          <p className="text-foreground-500 text-sm max-w-lg mx-auto">
            真实剧迷的真实评价，每一句都发自内心
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 max-w-5xl mx-auto">
          {commentItems.map((comment) => (
            <div
              key={comment.name}
              className="bg-background-50 rounded-xl border border-background-200/30 p-5"
            >
              <div className="flex items-center gap-3 mb-3">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0 bg-background-200">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                    onError={(e) => {
                      (e.target as HTMLElement).style.display = 'none';
                    }}
                  />
                </div>
                <div>
                  <div className="text-sm font-medium text-foreground-300">{comment.name}</div>
                  <div className="text-xs text-foreground-600">{comment.date}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-400 leading-relaxed mb-3">
                "{comment.content}"
              </p>
              <div className="flex items-center gap-1 text-xs text-foreground-600">
                <i className="ri-thumb-up-line" />
                <span>{comment.likes.toLocaleString()}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}